export type AppEnvironment = 'DEV' | 'DEMO' | 'PROD';

export const getAppEnvironment = (): AppEnvironment => {
  const env = process.env.REACT_APP_ENVIRONMENT?.toUpperCase();

  if (env === 'DEV' || env === 'DEMO' || env === 'PROD') {
    return env;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'DEV';
  }

  return 'PROD';
};

export const APP_ENV = getAppEnvironment();

export const isDemoEnv = APP_ENV === 'DEMO';
export const isDevEnv = APP_ENV === 'DEV';
export const isProdEnv = APP_ENV === 'PROD';

export const allowApiUsers = APP_ENV !== 'PROD';
export const showPlanStep = APP_ENV !== 'DEMO';
export const useDynamicPlans = APP_ENV !== 'DEMO';
